import { BLOOM_DEFAULTS } from '@shared/core/website/headerMotion/headerMotion.catalog';
import type { HeaderMotionOptions } from '@shared/core/website/headerMotion/headerMotion.types';

/**
 * Sanitises saved Bloom options. Bloom has no tuning knobs, so every saved key is dropped and the
 * result is always the catalog's `BLOOM_DEFAULTS`. Pure and never throws, so a hand-edited or stale
 * blob still renders.
 */
export const parseBloomOptions = (_raw: Readonly<Record<string, unknown>>): HeaderMotionOptions => BLOOM_DEFAULTS;
